import { render, staticRenderFns } from "./AddWidgetModal.vue?vue&type=template&id=2fecc8e6"
import script from "./AddWidgetModal.vue?vue&type=script&lang=js"
export * from "./AddWidgetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports